import { Component, OnInit } from '@angular/core';  
import { ApiService } from '../../services/api.service';
import { environment } from 'environments/environment';
import { UserService } from 'app/services/user.service';
import { AppInsightSvc } from 'app/services/appInsights.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  //public isConfigReady = false;

constructor( 
  private apiSvc: ApiService,
  private userSvc: UserService,
  private appInsightSvc: AppInsightSvc
)  { }

  ngOnInit() {
  
    this.appInsightSvc.logPageView();
    var hostName = window.location.hostname;
    console.log("hostName", hostName);
    var apiUrl = "";

    switch (hostName) {
      case "localhost":
        //apiUrl = environment.urlToApi;
        //apiUrl =  "https://e3b565cd.ngrok.io/"; //DEBUGGING
        apiUrl =  "http://localhost:13333/";  //DEBUGGING
        break;
      case "atibalapiwebtemp.azurewebsites.net":
        apiUrl = "https://lectionaryapi20180530114501.azurewebsites.net/";
        break;
      case "lectionaryweb-dev.azurewebsites.net":
        apiUrl = "https://lectionaryapi-dev.azurewebsites.net/";
        break;
      case "lectionaryweb-stage.azurewebsites.net":
        apiUrl = "https://lectionaryapi-stage.azurewebsites.net/";
        break;
            case "dev-lectionaryweb.azurewebsites.net":
        apiUrl = "https://dev-lectionaryapi.azurewebsites.net/";
        break;
      default:
        apiUrl = "https://lectionaryapi.azurewebsites.net/";
        break;
    }

    if (apiUrl === "") {
      alert("API Url not configured");
      return;
    }

    this.apiSvc.baseUrl = apiUrl;

    //Set the baseUrl in localstorage. There is a static HTML file that will call the URL to display the Proper HTML document.
    this.apiSvc.assignBaseUrlToLocalStorage();

    this.userSvc.getLiveStatus();
 
  }

}
 